module.exports = __webpack_public_path__ + "img/logo.3e037eb8.png";